const selectorKeys = [
  // Pages view
  'pages_reorderPagesButton',
  'pages_collapsedPage', // append page given name
  'pages_deletePageButton',
  'pages_addPageButton',
  'pages_editDesignButton',

  // Reorder pages view
  'reorderPages_backButton',
  'reorderPages_pageDragHandle', // append page given name
  'reorderPages_pageVisibilityToggle', // append page given name

  // Sections view
  'sections_editPageSettingsButton',
  'sections_addPrimaryButton',
  'sections_addElementButton',
  'sections_collapsedSection', // append section type
  'sections_collapsedPrimaryText',
  'sections_collapsedEditButton',
  'sections_collapsedField', // append field name
  'sections_addToPageButton',
  'sections_reorderSectionsLink',

  // Reorder sections view
  'reorderSections_backButton',
  'reorderSections_sectionDragHandle', // append section type

  // Page settings view
  'pageSettings_cancelButton',
  'pageSettings_pageNameInput',
  'pageSettings_textAlignmentSelector', // append left/center/right
  'pageSettings_imageSizeSlider',
  'pageSettings_pageDividerSelector',
  'pageSettings_pageShowMapSelector',
  'pageSettings_saveButton',

  // Edit section view
  'editSection_editField', // append field name
  'editSection_addPhotoButton',
  'editSection_galleryItemDragHandle',
  'editSection_changePhotoButton',
  'editSection_removePhotoButton',
  'editSection_editPhotoButton',
  'editSection_deleteButton',
  'editSection_cancelButton',
  'editSection_saveButton',

  // Media manager view
  'media_uploadButton',
  'media_manageLibraryLink',
  'media_libraryItem',
  'media_cancelButton',
  'media_selectButton',
  'mediaDelete_backButton',
  'mediaDelete_cancelButton',
  'mediaDelete_libraryItem',
  'mediaDelete_deleteButton',

  // Add section view
  'addSection_backButton',
  'addSection_addPrimaryButton',
  'addSection_addElement', // append section type

  // Website display
  'website_displayPageTitle', // append page given name
  'website_displaySection', // append section type
] as const;

export const selectors = Object.fromEntries(
  selectorKeys.map((key) => [
    key,
    key,
  ])
) as Record<typeof selectorKeys[number], string>;
